<template>
  <li>
    <div
    :class="{bold: model.is_label}"
    class="tree-item-block">
      <span
      @click="toggle">
        <span
        class="open_display"
        v-if="model.children && model.children.length > 0">
          <i
          v-if="model.open"
          class="caret-down"></i>
          <i v-else class="caret-right"></i>
        </span>
        <input 
        class="edit"
        v-if="model.editing"
        @input="onInput"
        :placeholder="new_model.n"
        v-model="new_model.n"/>
        <span 
        v-else>
        {{model.n}}
        </span>
      </span>
      <div class="tree-button-block">
        <div
        v-if="model.editing"
        class="button"
        @click="onSave">
          <i class="save2"></i>
        </div>
        <div 
        v-else
        class="button"
        @click="startEdit">
          <i class="pencil"></i>
        </div>
        <div class="button"
        @click="addChild">
          <i class="plus"></i>
        </div>
        <div class="button"
        @click="delChild">
          <i class="remove"></i>
        </div>
      </div>
    </div>
    <ul v-show="model.open">
      <v-tree-item
      @update="onUpdate"
      @edit="onStartEdit"
      @del="onDel"
      class="tree-item"
      v-for="child_model in model.children"
      :key="child_model.id"
      :model="child_model">
      </v-tree-item>
    </ul>
  </li>
</template>

<script>
// import { EventBus } from './tree-event-bus.js'

export default {
  props: {
    model: Object
  },
  data: function () {
    return {
      // open: false,
      // editing: false,
      new_model: {
        id: '',
        pid: '',
        n: ''
      }
    }
  },
  methods: {
    delChild: function () {
      console.log('delChild')
      this.$emit('del', this.model)
    },
    onDel: function (item) {
      let item_index = this.model.children.indexOf(item)
      if (item_index > -1) {
        this.model.children.splice(item_index, 1)
      }
    },
    startEdit: function () {
      console.log('startEdit')
      this.new_model.id = this.model.id
      this.new_model.pid = this.model.pid
      this.new_model.n = this.model.n
      this.$emit('edit', this.model)
    },
    onStartEdit: function (item) {
      let item_index = this.model.children.indexOf(item)
      let item_model = this.model.children[item_index]
      console.log('onStartEdit', item_model)
      item_model.editing = true
    },
    toggle: function () {
      this.model.open = !this.model.open
    },
    onInput: function (e) {
      this.new_model.n = e.target.value
    },
    onSave: function (e) {
      this.$emit('update', this.model, this.new_model.n)
    },
    onUpdate: function (item, new_name) {
      // update http request here

      let item_index = this.model.children.indexOf(item)
      let item_model = this.model.children[item_index]
      item_model.n = new_name
      let post_data
      let url

      if (item_model.isNew) {
        url = global.app_path + 'main.php?action=add_attribute'
        post_data = {
          pid: item_model.pid,
          n: new_name,
          is_label: item_model.is_label
        }
      }
      else {
        url = global.app_path + 'main.php?action=set_attribute'
        post_data = {
          id: item_model.id,
          n: new_name
        }
      }

      post_data.token = global.token

      this.$http.post(
        url,
        post_data
      )
      .then((response) => {
        item_model.editing = false
        if (item_model.isNew) {
          item_model.id = response.body.id
          item_model.isNew = false
        }
      }, (response) => {
        // error callback
      })
    },
    addChild: function () {
      let newItem

      if (this.model.is_label) {
        newItem = {
          pid: this.model.id,
          is_label: false,
          isNew: true,
          editing: true,
          open: true,
          n: 'Nouveau libellé'
        }
      }
      else {
        newItem = {
          pid: this.model.id,
          is_label: true,
          isNew: true,
          editing: true,
          open: true,
          n: 'Nouvel item'
        }
      }

      if (!this.model.children) {
        this.model.children = []
      }

      // newItem.id = 'new_item-' + Math.random()
      newItem.id = 'new_item-' + this.model.children.length
      this.model.children.push(newItem)
      this.open = true
    }
  },
  getChild: function () {

  },
  mounted: function () {
    // this.bus = EventBus
  }
}
</script>

<style>
.tree {
  width: 100%;
}

.tree-item {
  cursor: pointer;
  width: 100%;
}
.bold {
  font-weight: bold;
}
.tree ul {
  width: 100%;
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: none;
}

.tree-item-block {
  margin: 0px !important;
  transition: none;
  line-height: 48px;
  height: 48px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  margin: 0;
  padding: 0;
  font-size: 16px;
  background: 0 0;
  width: 100%;
}

.tree-item-block > span.open_display {
  padding: 10px;
}

.tree-button-block {
  display: inline-block;
}

.tree-button-block > .button {
  transition: none;
  line-height: 40px;
  height: 40px;
  margin: 4px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  background: 0 0;
}

.tree-button-block {
  float: right;
}

.edit0 {
  position: relative;
  margin: 0;
  font-size: 24px;
  font-family: inherit;
  font-weight: inherit;
  line-height: 1.4em;
  border: 0;
  color: inherit;
  line-height: 48px;
  height: 48px;
  padding: 6px;
  border: 1px solid #999;
  box-shadow: inset 0 -1px 5px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 }
</style>
